import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/pro-solid-svg-icons';

import { connect } from 'react-redux';

import PropertyManagementModal from './modal';
import { USD } from 'helpers/formatters/number_formats';

export function PropertyManagementTable({
  allowPropertyManagementDeals,
  isParentCompanyUser,
  propertyManagementGrossCommissionTotal,
  propertyManagementRoyaltyPercent,
}) {
  const [showModal, setShowModal] = useState();

  return (
    <div className="d-flex flex-column gap-3">
      <h6>Property Management</h6>
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>Status</th>
              <th className="text-end">YTD Gross Commission</th>
              <th className="text-end">Royalty Percentage</th>
              {isParentCompanyUser && <th/>}
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>{allowPropertyManagementDeals ? 'Enabled' : 'Disabled'}</td>
              <td className="text-end">
                {USD.format(propertyManagementGrossCommissionTotal)}
              </td>
              <td className="text-end">
                {propertyManagementRoyaltyPercent ? `${propertyManagementRoyaltyPercent}%` : '--'}
              </td>
              {isParentCompanyUser &&
                <td style={{ width: 0 }}>
                  <a className="clickable text-nowrap" name="show-modal-link" onClick={() => setShowModal(true)}>
                    <FontAwesomeIcon fixedWidth icon={faEdit} /> Edit
                  </a>
                </td>
              }
            </tr>
          </tbody>
        </table>
      </div>

      <PropertyManagementModal show={showModal} onClose={() => setShowModal(false)} />
    </div>
  );
}

PropertyManagementTable.propTypes = {
  allowPropertyManagementDeals: PropTypes.bool,
  isParentCompanyUser: PropTypes.bool,
  propertyManagementGrossCommissionTotal: PropTypes.number,
  propertyManagementRoyaltyPercent: PropTypes.number,
};

const mapStateToProps = ({ isParentCompanyUser, propertyManagement }) => ({
  allowPropertyManagementDeals: propertyManagement.allowDeals,
  isParentCompanyUser,
  propertyManagementGrossCommissionTotal: propertyManagement.grossCommissionTotal,
  propertyManagementRoyaltyPercent: propertyManagement.royaltyPercent,
});

export default connect(mapStateToProps)(PropertyManagementTable);
